import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("sakshi_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sakshi_token", data.access_token);
    localStorage.setItem("sakshi_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("sakshi_token");
    localStorage.removeItem("sakshi_user");
    setUser(null);
    window.location.href = "/login";
  };

  useEffect(() => {
    const t = localStorage.getItem("sakshi_token");
    if (t && !user) {
      setLoading(true);
      api.get("/auth/me").then(({ data }) => {
        setUser(data);
        localStorage.setItem("sakshi_user", JSON.stringify(data));
      }).catch(() => {}).finally(() => setLoading(false));
    }
  }, []);

  return <AuthCtx.Provider value={{ user, login, logout, loading }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
